const SCRIPT_TAG = 'script';

export function injectGoogleMapsScript(apiKey, messenger, eventName) {
	let url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
	let scriptId = 'googleMap';
	injectScript(document, scriptId, url, function () {
		messenger.publish(eventName, {});
	});
}

/**
 * Asynchronously injects a script into the current document and 
 * @param {object} document
 * @param {string} scriptPath
 * @param {string} scriptId
 * @param {function} onScriptLoaded
 */
export function injectScript(document, scriptId, scriptPath, onScriptLoaded) {
	let js, fjs = document.getElementsByTagName(SCRIPT_TAG)[0];

	// if a script with this id exists already, skip it
	if (document.getElementById(scriptId)) {
		return;
	}

	//configure element
	js = document.createElement(SCRIPT_TAG);
	js.id = scriptId;
	js.onload = onScriptLoaded;
	js.src = scriptPath;

	//inject
	fjs.parentNode.insertBefore(js, fjs);
}


/** WEBPACK FOOTER **
 ** ./src/modules/common/ScriptInjector.js
 **/